/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { LeaveOrganizationMutationResponse, LeaveOrganizationPathParams, LeaveOrganization400, LeaveOrganization401, LeaveOrganization403, LeaveOrganization404, LeaveOrganization409, LeaveOrganization500 } from "../../types/organizationController/LeaveOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { leaveOrganization } from "../../client/organizationController/leaveOrganization.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const leaveOrganizationMutationKey = () => [{ url: '/api/organizations/:organizationId/leave' }] as const

export type LeaveOrganizationMutationKey = ReturnType<typeof leaveOrganizationMutationKey>

export function leaveOrganizationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = leaveOrganizationMutationKey()
        return mutationOptions<LeaveOrganizationMutationResponse, ResponseErrorConfig<LeaveOrganization400 | LeaveOrganization401 | LeaveOrganization403 | LeaveOrganization404 | LeaveOrganization409 | LeaveOrganization500>, {organizationId: LeaveOrganizationPathParams["organizationId"]}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId }) => {
            return leaveOrganization(organizationId, config)
          },
        })

}

/**
 * @summary Leave organization
 * {@link /api/organizations/:organizationId/leave}
 */
export function useLeaveOrganization<TContext>(options: 
{
  mutation?: UseMutationOptions<LeaveOrganizationMutationResponse, ResponseErrorConfig<LeaveOrganization400 | LeaveOrganization401 | LeaveOrganization403 | LeaveOrganization404 | LeaveOrganization409 | LeaveOrganization500>, {organizationId: LeaveOrganizationPathParams["organizationId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? leaveOrganizationMutationKey()

          const baseOptions = leaveOrganizationMutationOptions(config) as UseMutationOptions<LeaveOrganizationMutationResponse, ResponseErrorConfig<LeaveOrganization400 | LeaveOrganization401 | LeaveOrganization403 | LeaveOrganization404 | LeaveOrganization409 | LeaveOrganization500>, {organizationId: LeaveOrganizationPathParams["organizationId"]}, TContext>
          

          return useMutation<LeaveOrganizationMutationResponse, ResponseErrorConfig<LeaveOrganization400 | LeaveOrganization401 | LeaveOrganization403 | LeaveOrganization404 | LeaveOrganization409 | LeaveOrganization500>, {organizationId: LeaveOrganizationPathParams["organizationId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LeaveOrganizationMutationResponse, ResponseErrorConfig<LeaveOrganization400 | LeaveOrganization401 | LeaveOrganization403 | LeaveOrganization404 | LeaveOrganization409 | LeaveOrganization500>, {organizationId: LeaveOrganizationPathParams["organizationId"]}, TContext>
      
}